const lastEventTimes = new Map<string, number>()
const RATE_LIMIT_INTERVAL = 1000

export function canSendEvent (eventKey: string): boolean {
  const now = Date.now()
  const lastEventTime = lastEventTimes.get(eventKey) || 0

  if (now - lastEventTime > RATE_LIMIT_INTERVAL) {
    lastEventTimes.set(eventKey, now)
    return true
  }
  return false
}
